import { ButtonProps as ButtonPropsAlias } from './Button';

export { Button } from './Button';

export type ButtonProps = ButtonPropsAlias;
